import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { IconFile05 } from "@pentabd/icons";
import { Button, SectionHeader } from "@pentabd/ui";

import { LeaveHistorySummary, LeaveHistoryTable } from "./components";

import { useUser } from "@hooks/useUser";

import { getAccess } from "@helpers/permissionController";

import { ROUTES } from "@constants/routes";

const { HRM, CREATE, UPDATE } = ROUTES;
const { LEAVE } = HRM;

export interface LeavePropsType {
  id: number | null;
  isProfileDisabled: boolean;
  isEditEmployee: boolean;
}

const Leave = ({ id, isProfileDisabled, isEditEmployee }: LeavePropsType) => {
  const { t } = useTranslation();

  const { user } = useUser();
  const { employeeMasterId, realm_roles: roles } = user || {};

  return (
    <>
      <div className="pt-10">
        <SectionHeader
          title={t("EMPLOYEE.LEAVE_INFO.HEADING")}
          subtitle={t("EMPLOYEE.LEAVE_INFO.DESCRIPTION")}
          components={
            !isProfileDisabled
              ? [
                  getAccess(roles, "LEAVE_UPDATE") ? (
                    <Link to={`${LEAVE}/${id}/${UPDATE}`}>
                      <Button
                        size="sm"
                        className="py-5 bg-primary-lightest btn-text-700 border border-primary-lighter"
                      >
                        {t("EMPLOYEE.LEAVE_INFO.BUTTONS.UPDATE_BALANCE")}
                      </Button>
                    </Link>
                  ) : (
                    <></>
                  ),
                  Number(employeeMasterId) === Number(id) ? (
                    <Link to={`${LEAVE}/${CREATE}`}>
                      <Button
                        size="sm"
                        className="py-5 btn-bg-600 text-white"
                        disabled={isEditEmployee}
                      >
                        <IconFile05 size="20" fill="white" />
                        {t("EMPLOYEE.LEAVE_INFO.BUTTONS.APPLY")}
                      </Button>
                    </Link>
                  ) : (
                    <></>
                  ),
                ]
              : undefined
          }
        />
      </div>
      {!isProfileDisabled && <LeaveHistorySummary employeeId={id as any} />}
      <LeaveHistoryTable employeeId={id as any} />
    </>
  );
};

export default Leave;
